import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import '../styling/calendar.css';
import { useState } from 'react';

export default function EventCalendar({calendarArray}) {
    // const [calendarValues, setCalendarValues] = useState(calendarArray);
    const [value, onChange] = useState(new Date());

    function isSameDay(date1, date2) {
        return (
            new Date(date1).getFullYear() === date2.getFullYear() &&
            new Date(date1).getMonth() === date2.getMonth() &&
            new Date(date1).getDate() === date2.getDate()
        );
    }

    return (
        <div className="border rounded p-4 text-center">
            <Calendar  
                prevLabel="‹"
                nextLabel="›" 
                selectRange={false}
                tileClassName={({ date }) =>
                    calendarArray.some(d => isSameDay(d, date)) ? 'booked' : null
                }
                next2Label={null}
                prev2Label={null}
                // tileClassName={'highlight-green'}
                // onChange={onChange} 
                value={value} 
            />
        </div>
    );
}
